import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPending = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6 3C6 2.44772 6.44772 2 7 2H17C17.5523 2 18 2.44772 18 3V5.34315C18 6.66923 17.4732 7.941 16.5355 8.87868L12.7071 12.7071C12.3166 13.0976 11.6834 13.0976 11.2929 12.7071L7.46446 8.87868C6.52678 7.941 6 6.66923 6 5.34315V3ZM8 4V5.34315C8 6.1388 8.31607 6.90186 8.87868 7.46446L12 10.5858L15.1213 7.46447C15.6839 6.90186 16 6.1388 16 5.34315V4H8Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18 21C18 21.5523 17.5523 22 17 22H7C6.44771 22 6 21.5523 6 21V18.6569C6 17.3308 6.52678 16.059 7.46447 15.1213L11.2929 11.2929C11.6834 10.9024 12.3166 10.9024 12.7071 11.2929L16.5355 15.1213C17.4732 16.059 18 17.3308 18 18.6569V21ZM16 20V18.6569C16 17.8612 15.6839 17.0981 15.1213 16.5355L12 13.4142L8.87868 16.5355C8.31607 17.0981 8 17.8612 8 18.6569V20H16Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.908 19H13.092C13.5935 19 14 18.5935 14 18.092C14 17.8225 13.8803 17.5669 13.6733 17.3944L12.6402 16.5335C12.2693 16.2244 11.7307 16.2244 11.3598 16.5335L10.3267 17.3944C10.1197 17.5669 10 17.8225 10 18.092C10 18.5935 10.4065 19 10.908 19Z",
			fill: "currentColor"
		})
	]
});
export default SvgPending;
